import { Component } from '@angular/core';

@Component({
  selector: 'wp-input-error',
  templateUrl: 'input-error.component.html',
  styleUrl: 'input-error.component.scss',
})
export class InputErrorComponent {}
